import {
  ESIM_ACTIVATION_CODE_ERROR,
  ESIM_ACTIVATION_CODE_REQUEST,
  ESIM_ACTIVATION_CODE_SUCCESS,
  ESIM_ACTIVATION_CODE_RESET,
  ESIM_RETRIGGER_MULTI_RECP_REQUEST,
  ESIM_RETRIGGER_MULTI_RECP_SUCCESS,
  ESIM_RETRIGGER_MULTI_RECP_ERROR,
  SIM_ACTIVATION_STATUS_REQUEST,
  SIM_ACTIVATION_STATUS_SUCCESS,
  SIM_ACTIVATION_STATUS_ERROR,
  SIM_ACTIVATION_SUBMIT_REQUEST,
  SIM_ACTIVATION_SUBMIT_SUCCESS,
  SIM_ACTIVATION_SUBMIT_ERROR
} from './actionTypes';
import { ESIMActivationReq } from './models/types';

export const getESIMActivationCode = {
  request: (esimActReq): ESIMActivationReq => ({
    type: ESIM_ACTIVATION_CODE_REQUEST,
    esimActReq
  }),
  success: (data) => ({ type: ESIM_ACTIVATION_CODE_SUCCESS, data }),
  failure: (error) => ({ type: ESIM_ACTIVATION_CODE_ERROR, error })
};

export const eSIMActivationResetState = {
  request: () => ({
    type: ESIM_ACTIVATION_CODE_RESET
  })
};

export const eSIMTriggerMultiRecp = {
  request: (payload) => ({
    type: ESIM_RETRIGGER_MULTI_RECP_REQUEST,
    payload
  }),
  success: (data) => ({ type: ESIM_RETRIGGER_MULTI_RECP_SUCCESS, data }),
  failure: (error) => ({ type: ESIM_RETRIGGER_MULTI_RECP_ERROR, error })
}

export const simActivationStatus = {
  request: (reqData): any => ({
    type: SIM_ACTIVATION_STATUS_REQUEST,
    reqData
  }),
  success: (data): any => ({ type: SIM_ACTIVATION_STATUS_SUCCESS, data }),
  failure: (error): any => ({ type: SIM_ACTIVATION_STATUS_ERROR, error })
}

export const simActivationSubmit = {
  request: (reqData): any => ({
    type: SIM_ACTIVATION_SUBMIT_REQUEST,
    reqData
  }),
  success: (data): any => ({ type: SIM_ACTIVATION_SUBMIT_SUCCESS, data }),
  failure: (error): any => ({ type: SIM_ACTIVATION_SUBMIT_ERROR, error })
}